import { type InsuranceCorporateIdentity } from "../types";

export function IKKLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient
          id="paint0_linear_3_788"
          x1="408"
          y1="325.987"
          x2="103"
          y2="325.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0095BC" />
          <stop offset="0.5" stopColor="#003976" />
          <stop offset="1" stopColor="#0095BC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3_788"
          x1="211.298"
          y1="45.6978"
          x2="211.298"
          y2="453.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#019BC1" />
          <stop offset="0.5" stopColor="#019CC2" stopOpacity="0.4" />
          <stop offset="1" stopColor="#029CC2" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3_788"
          x1="211.298"
          y1="45.6978"
          x2="211.298"
          y2="453.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#019BC1" />
          <stop offset="0.5" stopColor="#019CC2" stopOpacity="0.4" />
          <stop offset="1" stopColor="#029CC2" />
        </linearGradient>
      </defs>
      <path
        d="M399.938 366.813L260.203 325.808L344.178 283.459C348.209 281.442 350.225 278.081 350.225 273.376V198.088C350.225 190.021 342.163 184.644 334.773 188.005L260.203 220.271L162.791 262.62L109.718 285.475C105.687 287.492 103 291.525 103 295.559V356.058C103 360.763 105.687 364.796 110.39 366.141L162.791 384.291L260.203 417.901L393.22 464.284C400.61 466.973 408 461.595 408 454.201V377.568C407.328 372.863 404.641 368.157 399.938 366.813Z"
        fill="url(#paint0_linear_3_788)"
      />
      <path
        d="M251.74 143.364C274.076 121.022 274.076 84.7972 251.74 62.4547C229.404 40.1122 193.191 40.1122 170.856 62.4547C148.52 84.7972 148.52 121.022 170.856 143.364C193.191 165.707 229.404 165.707 251.74 143.364Z"
        fill="url(#paint1_linear_3_788)"
      />
      <path
        d="M261 190.109C261 184.711 256.269 179.987 250.862 179.987H173.138C167.731 179.987 163 184.711 163 190.109V443.987C163 449.32 167.731 453.987 173.138 453.987H250.862C256.269 453.987 261 449.32 261 443.987V417.32V384.5V190.109Z"
        fill="url(#paint2_linear_3_788)"
      />
    </svg>
  );
}

export const IKK: InsuranceCorporateIdentity = {
  id: "ikk",
  name: "IKK",
  logo: IKKLogo,
  backgroundColor: "#D5ECF5",
  textColor: "#003976",
  wildcard: "ikk",
  type: "statutory",
};
